const API_BASE = (import.meta as any).env?.VITE_API_BASE?.trim() || ''

async function handleResponse<T>(url: string, res: Response): Promise<T> {
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    const err = new Error(`${res.status} ${res.statusText} from ${url}${text ? ` -> ${text}` : ''}`)
    console.error('api error', err)
    throw err
  }
  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}

export async function apiGet<T>(path: string, init?: RequestInit): Promise<T> {
  const url = API_BASE ? `${API_BASE}${path}` : path
  try {
    const res = await fetch(url, {
      ...init,
      method: init?.method ?? 'GET',
      headers: {
        accept: 'application/json',
        ...(init?.headers || {}),
      },
    })
    return await handleResponse<T>(url, res)
  } catch (err) {
    console.error('apiGet error', url, err)
    throw err
  }
}

export async function apiPost<T>(path: string, body: any, init?: RequestInit): Promise<T> {
  const url = API_BASE ? `${API_BASE}${path}` : path
  try {
    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body ?? {}),
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        ...(init?.headers || {}),
      },
      ...init,
    })
    return await handleResponse<T>(url, res)
  } catch (err) {
    console.error('apiPost error', url, err)
    throw err
  }
}

export { API_BASE }
